import React, { useState } from "react";
import {  useSelector, useDispatch } from "react-redux";
import UserBadge from "./user-badge";
import Settings from "./settings";
import CompanyList from "../general/company-list.jsx";
import AccountantList from "../general/accountant-list";
// import { FEATURE_TOGGLE_ASK } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import LogoHeader from "../../assets/img/logoDigital.svg";
import LogoHeaderWhite from "../../assets/img/logoDigitalWhite.svg";
import NotificationsBadge from "../notificationsBadge";
import NotificationDrawer from "../notificationDrawer";
// import {usePermissions} from "../../customHooks";
import { useOutsideClickRef } from "../../customHooks";
import { getNotificationsList } from "../../store/actions/ncs/read";
import { getNotifyPreferences } from "../../store/actions/ncs/preferences";

import { getInitials } from "../../libs/utils";

import "./style.css";
import { FormattedMessage } from "react-intl";
import { useEffect } from "react";
import { FEATURE_TOGGLE_PARTIES, FEATURE_TOGGLE_TOUR } from "../../config";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils.js";

const Header = props => {
  const {
    changeFullTextSearch,
    openStudioModal,
    searchTerm,
    setNewPageCompanies,
    pageRef
  } = props;

  const dispatchAction = useDispatch();
  
  const auth = useSelector(state => state.auth);
  const company = useSelector(state => state.company);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const main = useSelector(state => state.main);
  const notificationsExist = useSelector(state => state.ncs.notifications.exist);
  const user = useSelector(state => state.user);

  const studioFind = GetSelectedCompanyStudio();

  // const activeAskIcon = false;
  const [activeAddressIcon /* setActiveBookIcon*/] = useState(false);
  const [showNotificationList, setShowNotificationList] = useState(false);
  const notificationsDrawerRef = useOutsideClickRef(() => showNotificationList && setShowNotificationList(false));
  const [menu, setMenu] = useState(localStorage.getItem("menuToggle")
    ? localStorage.getItem("menuToggle")
    : "unfold");

  const [page, setPage] = useState(1);

  useEffect(() => {
    document.body.className = menu +  " " + main.myType.toLowerCase();
  }, [menu]);

  useEffect(() => {
    if (main.menuToggle !== menu){
      setMenu(main.menuToggle);
    }
  }, [main.menuToggle]);

  useEffect(() => {
    if (window.Cypress) return;
    if (user && user?.profile?.ncsId){
      dispatchAction(getNotificationsList(auth.loginAuth, user?.profile?.ncsId));
      dispatchAction(getNotifyPreferences(auth, user?.profile?.ncsId));
    }
  }, []);

  const toggleMenu = () => {
    let menuType = menu === "unfold" ? "fold" : "unfold";
    localStorage.setItem("menuToggle", menuType);
    setMenu(menuType);
    dispatchAction({ type: "SET_MENU_TOGGLE", payload: menuType });
  };

  const renderCompanyList = () => {
    let findedCompany = company.companies.find(function(el) {
      return el.id === main.clientIdSelected;
    });
    const logoUrl = findedCompany?.logoUrl;

    return (
      <div className="companyBox" style={{ float: "left" }}>
        {!logoUrl ? (
          <div className="roundUser">
            <span>
              {main.companySelected && findedCompany
                ? getInitials(findedCompany.ragioneSociale)
                : "N/A"}{" "}
            </span>
          </div>
        ) : (
          <div
            className="logo-studio-container"
            style={{
              backgroundImage: `url(${logoUrl})`,
              width: "50px",
              height: "50px"
            }}
          ></div>
        )}

        <CompanyList
          pageRef={pageRef}
          changeFullTextSearch={val => changeFullTextSearch(val)}
          searchTerm={searchTerm}
          setNewPageCompanies={setNewPageCompanies}
          companyName={findedCompany && findedCompany.ragioneSociale}
        />
      </div>
    );
  };

  const renderAccountantList = () => {
    return (
      <div className="companyBox" style={{ float: "right" }}>
        <AccountantList />
      </div>
    );
  };

  const renderIconFoldUnfold = () => {
    let iconMenu = menu === "fold" ? "times" : "bars";
    return (
      <div style={{ textAlign: "center" }}>
        <div>
          <FontAwesomeIcon
            icon={["far", iconMenu]}
            style={{ fontSize: "24px", cursor: "pointer" }}
            className="fold-unfold-icon"
            onClick={toggleMenu.bind(this)}
          />
        </div>
        <div style={{ fontSize: "12px", textTransform: "uppercase" }}>
          <FormattedMessage id="generic.menu" />{" "}
        </div>
      </div>
    );
  };

  // const { isPermissionAsk } = usePermissions(currentPermissions);

  return (
    <div className="minHeader">
      <div className="leftArea">
        <div className="menuToggler" style={{ flexDirection: "column" }}>
          {renderIconFoldUnfold()}
        </div>
        <div className="logo">
          <img
            style={{ width: "100%" }}
            src={main.myType === "STUDIO" ? LogoHeader : LogoHeaderWhite}
            alt="logo Ts Digital "
          />
        </div>

        <div className="companySelectorWrapper dbx-gainsight-tour-companySel">
          {main.myType === "STUDIO" &&
          (company.companies.length > 0 ||
            (company.preSearchedCompany &&
              company.preSearchedCompany.length > 0))
            ? renderCompanyList()
            : null}
          {main.myType !== "STUDIO" ? renderAccountantList() : null}
        </div>
      </div>
      <div className="rightArea">
        <div className="userArea">
          {FEATURE_TOGGLE_TOUR === "true" && (
            <div
              className="dbx-gainsight-tour-start"
              onClick={() => {
                if (main.myType === "STUDIO" && window.aptrinsic) {
                  if (window.location.href.indexOf("/#/documenti") > -1) {
                    window.aptrinsic("track",
                      "digital-box:TOUR-DOCUMENTS-ACCOUNTANT");
                  } else {
                    window.aptrinsic("track", "digital-box:TOUR-ACCOUNTANT");
                  }
                } else if (window.aptrinsic) {
                  window.aptrinsic("track", "digital-box:TOUR-COMPANY");
                }
              }}
              style={{ display: "flex", height: "100%" }}
            >
              <div
                className={
                  "divBadge" + (main.myType === "STUDIO" ? " divBadgeBianco" : "")
                }
                id="tourIcon"
              >
                <FontAwesomeIcon
                  icon={["fas", "question-circle"]}
                  style={{ fontSize: 24 }}
                />
              </div>
            </div>
          )}
          {company.companies &&
          company.companies.length > 0 &&
          currentPermissions.permissionUser.userPermissions !== null ? (
              <Settings />
            ) : null}
          {FEATURE_TOGGLE_PARTIES === "true" && main.myType !== "STUDIO" && studioFind?.taxRegion !== "ES"  && (
            <Link to={"/parties"}>
              <div
                onClick={e => {
                  if (window.aptrinsic) {
                    window.aptrinsic("track", "digital-box:PARTIES");
                  }
                }}
                className={
                  "divBadge partiesHeaderIcon " +
                  (activeAddressIcon ? "active" : null)
                }
                id="partiesIcon"
              >
                <FontAwesomeIcon
                  icon={["far", "book-open"]}
                  style={{ fontSize: "24px" }}
                />
              </div>
            </Link>
          )}
          {company.companies && company.companies.length > 0 ? (
            <div className="userDetails dbx-gainsight-tour-notifications">
              <NotificationsBadge
                onClick={() => {                                               
                  if (window.aptrinsic) {
                    window.aptrinsic("track",
                      "digital-box:NOTIFICATION_POPOVER");
                  }
                  setShowNotificationList(prevState => {                    
                    return !prevState;
                  });
                }}
                active={showNotificationList}
                exist={notificationsExist}
              />
            </div>
          ) : null}
          <div>
            <UserBadge
              className="userDetails"
              openStudioModal={ () => {openStudioModal();}}
            />
            <NotificationDrawer
              ref={notificationsDrawerRef}
              showNotificationList={showNotificationList}
              setShowNotificationList={setShowNotificationList}
              page={page}
              setPage={setPage}
              onClose={() => {
                setShowNotificationList(false);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
